// extracted by mini-css-extract-plugin
export default {"numberInputWrapper":"NumberInput_numberInputWrapper__UKilK"};